
import { getQueryPath } from "ui-io/get-query-path";
import fetchApi from "../fetch-api";
import { AccumulatedFundingIO } from "../funding-io";
import { MarketCapT } from "../common-io";

type ParamsPropsT = {
  date?: string;
  year?: number;
	marketCapital?:MarketCapT;
};

export const getAccumulatedFunding = (props: ParamsPropsT) => {
  let params = props;
  const queryPath = getQueryPath({...params});
  return {
    queryKey: ["ACCUMULATED_FUNDING", queryPath],
    queryFn: () =>
      fetchApi({
        service:"core-service",
        headers:{method: 'GET'},
        pathname: `/accumulated-funding-by-date?${ queryPath}`,
        codec: AccumulatedFundingIO,
      })
  };
};
